// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2TpaA","productName":"Table_productName__75VSK"};